import React, { Component } from "react";
import { connect } from "react-redux";
import { PageHeader, Popconfirm, message, Tooltip, Tag, Select, Checkbox } from "antd";
import { EditOutlined, CheckCircleOutlined, StopOutlined, EyeOutlined, QrcodeOutlined, UploadOutlined } from "@ant-design/icons";
import { ButtonItem, SegmentedItem, TableItemDinamico, SelectItem, TourItem } from "../../../../Components/Items";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import { cmmsPost, ESTATUS_EQUIPO, estatusEquipo, formatoFecha } from "../cmmsComun";
import ModalActivo from "./ModalActivo";
import ModalEtiquetasCMMS from "../componentes/ModalEtiquetasCMMS";
import SelectContratoCMMS from "../componentes/SelectContratoCMMS";

const { Option } = Select;

// Listado de Activos CMMS (equipo medico de los clientes). Paginado en el servidor.
class Activos extends Component {
    refFiltros = React.createRef();
    refTabla = React.createRef();

    state = {
        loading: false,
        activos: [],
        totalRecords: 0,
        valor: 1,
        tipos: [],
        clienteId: null,
        sinCliente: false,
        tipoEquipoId: null,
        estatusEquipo: null,
        contratoId: null,
        sinContrato: false,
        modal: false,
        modo: "agregar",
        activoId: null,
        openTour: false,
        seleccionados: [],
        modalEtiquetas: false,
        idsEtiquetas: [],
    };

    componentDidMount() {
        this.consultarTipos();
    }

    consultarTipos = async () => {
        try {
            const res = await cmmsPost(this.props, "selectTiposEquipo", { valor: 1 });
            if (res.data.success === 2) this.setState({ tipos: res.data.tipos });
        } catch (error) {
            console.log(error);
        }
    };

    consultarActivos = async (params) => {
        this.setState({ loading: true });
        try {
            const res = await cmmsPost(this.props, "selectActivosCMMS", params);
            if (res.data.success === 2) {
                this.setState({ activos: res.data.data, totalRecords: res.data.totalRecords || 0 });
            } else {
                this.setState({ activos: [], totalRecords: 0 });
            }
        } catch (error) {
            console.log(error);
            message.error("Error al consultar los activos");
        } finally {
            this.setState({ loading: false });
        }
    };

    // Los filtros de la cabecera viajan como "externalFilters" de la tabla; se mezclan
    // con los que ya tiene (valor del Segmented y texto del buscador).
    aplicarFiltros = (cambios) => {
        this.setState(cambios, () => {
            if (!this.tableRef) return;
            this.tableRef.updateExternalFilters({
                ...(this.tableRef.state?.externalFilters || {}),
                clienteId: this.state.sinCliente ? null : this.state.clienteId,
                sinCliente: this.state.sinCliente,
                tipoEquipoId: this.state.tipoEquipoId,
                estatusEquipo: this.state.estatusEquipo,
                contratoId: this.state.sinContrato ? null : this.state.contratoId,
                sinContrato: this.state.sinContrato,
                valor: this.state.valor,
            });
        });
    };

    recargar = () => {
        if (this.tableRef) this.tableRef.fetchData();
    };

    cambiarEstado = async (id, estado) => {
        try {
            const res = await cmmsPost(this.props, "cambiarEstadoActivoCMMS", { id, estado });
            if (res.data.success === 2) {
                message.success(estado === 1 ? "Activo habilitado" : "Activo deshabilitado");
                this.recargar();
            } else {
                message.error(res.data.message || "No se pudo cambiar el estado");
            }
        } catch (error) {
            console.log(error);
        }
    };

    verFicha = (id) => this.props.history.push("/panel/cmmsFichaActivo", { id });

    render() {
        const columns = [
            { title: "Folio", dataIndex: "codigo", key: "codigo", buscar: "codigo", sorter: true, width: 110 },
            { title: "Categoría", dataIndex: "categoria", key: "categoria", buscar: "categoria", sorter: true, width: 140 },
            { title: "Tipo de Activo", dataIndex: "tipoNombre", key: "tipoNombre", buscar: "tipoNombre", sorter: true, width: 180 },
            { title: "Marca", dataIndex: "marcaNombre", key: "marcaNombre", buscar: "marcaNombre", sorter: true, width: 120 },
            { title: "Modelo", dataIndex: "modeloNombre", key: "modeloNombre", buscar: "modeloNombre", sorter: true, width: 130 },
            {
                title: "No. Serie",
                dataIndex: "numeroSerie",
                key: "numeroSerie",
                buscar: "numeroSerie",
                sorter: true,
                width: 130,
                render: (value, record) => (record.sinSerie ? <span style={{ color: "#8c8c8c" }}>Sin serie</span> : value),
            },
            { title: "Inventario", dataIndex: "numeroInventario", key: "numeroInventario", buscar: "numeroInventario", width: 110 },
            { title: "ID Externo", dataIndex: "idExterno", key: "idExterno", buscar: "idExterno", width: 130 },
            {
                title: "Cliente",
                dataIndex: "clienteNombre",
                key: "clienteNombre",
                buscar: "clienteNombre",
                sorter: true,
                width: 220,
                render: (value, record) =>
                    record.clienteId ? (
                        <span>
                            {value}
                            {record.sucursalNombre ? <span style={{ color: "#8c8c8c" }}> · {record.sucursalNombre}</span> : null}
                        </span>
                    ) : (
                        <Tag>Sin cliente</Tag>
                    ),
            },
            {
                title: "Contrato",
                dataIndex: "contratoNombre",
                key: "contratoNombre",
                width: 170,
                render: (value, record) =>
                    value ? (
                        <Tooltip title="Abrir contrato">
                            <Tag
                                color={record.contratoEstatus === "vigente" ? "blue" : record.contratoEstatus === "porRenovar" ? "gold" : "default"}
                                style={{ cursor: "pointer" }}
                                onClick={() => this.props.history.push("/panel/cmmsContrato", { id: record.contratoId })}
                            >
                                {value}
                            </Tag>
                        </Tooltip>
                    ) : (
                        <span style={{ color: "#9aa7b4" }}>Sin contrato</span>
                    ),
            },
            {
                title: "Ubicación",
                dataIndex: "ubicacionNombre",
                key: "ubicacionNombre",
                buscar: "ubicacionNombre",
                width: 160,
                render: (value, record) => [value, record.area].filter(Boolean).join(" · "),
            },
            {
                title: "Estatus",
                dataIndex: "estatusEquipo",
                key: "estatusEquipo",
                sorter: true,
                width: 150,
                render: (value) => <Tag color={estatusEquipo(value).color}>{estatusEquipo(value).label}</Tag>,
            },
            { title: "Pertenencia", dataIndex: "pertenencia", key: "pertenencia", buscar: "pertenencia", sorter: true, width: 150 },
            { title: "Jerarquía", dataIndex: "jerarquia", key: "jerarquia", buscar: "jerarquia", sorter: true, width: 110 },
            {
                title: "Próx. preventivo",
                dataIndex: "fechaProximoPreventivo",
                key: "fechaProximoPreventivo",
                sorter: true,
                width: 120,
                render: (value) => formatoFecha(value),
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                fixed: "right",
                align: "center",
                width: 150,
                onCell: () => ({ className: "acciones-sin-hover", style: { textAlign: "center", padding: "4px" } }),
                render: (value) => (
                    <div className="acciones-container">
                        <Tooltip title="Etiqueta QR">
                            <ButtonItem type="default" size="small" blanco icon={<QrcodeOutlined />} onClick={() => this.setState({ modalEtiquetas: true, idsEtiquetas: [value._id] })} />
                        </Tooltip>
                        <Tooltip title="Ver ficha">
                            <ButtonItem type="default" size="small" blanco icon={<EyeOutlined />} onClick={() => this.verFicha(value._id)} />
                        </Tooltip>
                        <Tooltip title="Editar">
                            <ButtonItem type="default" size="small" cyan icon={<EditOutlined />} onClick={() => this.setState({ modal: true, modo: "editar", activoId: value._id })} />
                        </Tooltip>
                        <Popconfirm
                            title={value.estado === 1 ? "¿Deshabilitar este activo?" : "¿Habilitar este activo?"}
                            onConfirm={() => this.cambiarEstado(value._id, value.estado === 1 ? 2 : 1)}
                            okText="Sí"
                            cancelText="No"
                        >
                            <Tooltip title={value.estado === 1 ? "Deshabilitar" : "Habilitar"}>
                                {value.estado === 1 ? (
                                    <ButtonItem type="default" size="small" lima icon={<CheckCircleOutlined />} />
                                ) : (
                                    <ButtonItem type="default" size="small" rojo icon={<StopOutlined />} />
                                )}
                            </Tooltip>
                        </Popconfirm>
                    </div>
                ),
            },
        ];

        return (
            <>
                <PageHeader
                    title="Activos"
                    subTitle="Equipo médico de los clientes"
                    style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
                    extra={
                        <>
                            {window.innerWidth > 1000 && (
                                <SegmentedItem
                                    options={[
                                        { label: "Activo", value: 1 },
                                        { label: "Deshabilitado", value: 2 },
                                        { label: "Todos", value: 3 },
                                    ]}
                                    value={this.state.valor}
                                    onChange={(valor) => this.aplicarFiltros({ valor })}
                                />
                            )}
                            <ButtonItem
                                type="default"
                                icon={<QrcodeOutlined />}
                                disabled={!this.state.seleccionados.length}
                                onClick={() => this.setState({ modalEtiquetas: true, idsEtiquetas: this.state.seleccionados })}
                            >
                                Etiquetas{this.state.seleccionados.length ? ` (${this.state.seleccionados.length})` : ""}
                            </ButtonItem>
                            <ButtonItem type="default" icon={<UploadOutlined />} onClick={() => this.props.history.push("/panel/cmmsImportarActivos")}>
                                Importar
                            </ButtonItem>
                            <ButtonItem type="primary" olivo className="botonAgregar" onClick={() => this.setState({ modal: true, modo: "agregar", activoId: null })}>
                                Agregar Activo
                            </ButtonItem>
                            <ButtonItem type="link" blanco onClick={() => this.setState({ openTour: true })}>
                                ¿Cómo funciona?
                            </ButtonItem>
                        </>
                    }
                />
                <div
                    ref={this.refFiltros}
                    style={{ display: "flex", flexWrap: "wrap", gap: 10, alignItems: "center", background: "white", padding: "8px 12px", marginBottom: 10, border: "1px solid rgb(235, 237, 240)" }}
                >
                    <div style={{ width: 280 }}>
                        <SelectClientesItem
                            empresaId={this.props.empresaId}
                            headersToken={this.props.headersToken}
                            placeholder="Todos los clientes"
                            allowClear
                            width="100%"
                            disabled={this.state.sinCliente}
                            value={this.state.clienteId || undefined}
                            onChange={(clienteId) => this.aplicarFiltros({ clienteId: clienteId || null })}
                        />
                    </div>
                    <Checkbox checked={this.state.sinCliente} onChange={(e) => this.aplicarFiltros({ sinCliente: e.target.checked })}>
                        Sólo sin cliente
                    </Checkbox>
                    <div style={{ width: 240 }}>
                        <SelectContratoCMMS
                            empresaId={this.props.empresaId}
                            headersToken={this.props.headersToken}
                            clienteId={this.state.sinCliente ? null : this.state.clienteId}
                            disabled={this.state.sinContrato}
                            value={this.state.contratoId}
                            onChange={(contratoId) => this.aplicarFiltros({ contratoId })}
                        />
                    </div>
                    <Checkbox checked={this.state.sinContrato} onChange={(e) => this.aplicarFiltros({ sinContrato: e.target.checked })}>
                        Sólo sin contrato
                    </Checkbox>
                    <SelectItem
                        placeholder="Todos los tipos"
                        allowClear
                        width={220}
                        value={this.state.tipoEquipoId || undefined}
                        onChange={(tipoEquipoId) => this.aplicarFiltros({ tipoEquipoId: tipoEquipoId || null })}
                    >
                        {this.state.tipos.map((t) => (
                            <Option key={t._id} value={t._id}>
                                {t.nombre}
                            </Option>
                        ))}
                    </SelectItem>
                    <SelectItem
                        placeholder="Todos los estatus"
                        allowClear
                        width={200}
                        value={this.state.estatusEquipo || undefined}
                        onChange={(estatus) => this.aplicarFiltros({ estatusEquipo: estatus || null })}
                    >
                        {ESTATUS_EQUIPO.map((e) => (
                            <Option key={e.value} value={e.value}>
                                {e.label}
                            </Option>
                        ))}
                    </SelectItem>
                </div>
                <div ref={this.refTabla}>
                    <TableItemDinamico
                        onRef={(ref) => (this.tableRef = ref)}
                        totalRecords={this.state.totalRecords}
                        anadirValorFiltro={this.state.valor}
                        valorDefault={1}
                        setValor={(valor) => this.setState({ valor })}
                        setTextoFiltro={() => {}}
                        onFetchData={this.consultarActivos}
                        loading={this.state.loading}
                        size="small"
                        dataSource={this.state.activos}
                        columns={columns}
                        pagination={false}
                        filterStorageKey={"ActivosCMMSFiltrosTabla" + this.props.empresaId}
                        rowKey="_id"
                        rowSelection={{
                            selectedRowKeys: this.state.seleccionados,
                            onChange: (seleccionados) => this.setState({ seleccionados }),
                            preserveSelectedRowKeys: true,
                        }}
                        onRow={(record) => ({ onDoubleClick: () => this.verFicha(record._id) })}
                    />
                </div>

                <ModalActivo
                    visible={this.state.modal}
                    modo={this.state.modo}
                    activoId={this.state.activoId}
                    onClose={(codigo) =>
                        this.setState({ modal: false }, () => {
                            this.recargar();
                            if (codigo && this.state.modo === "agregar") this.verFicha(codigo);
                        })
                    }
                />

                <ModalEtiquetasCMMS visible={this.state.modalEtiquetas} ids={this.state.idsEtiquetas} onClose={() => this.setState({ modalEtiquetas: false })} />

                <TourItem
                    open={this.state.openTour}
                    onClose={() => this.setState({ openTour: false })}
                    steps={[
                        {
                            title: "Activos",
                            description:
                                "Cada activo es el expediente de un equipo médico de un cliente: su tipo, marca, modelo, serie, ubicación y estatus. No tiene relación con los Activos Fijos de la empresa.",
                            target: null,
                        },
                        {
                            title: "Filtros",
                            description:
                                "Filtre por cliente, por tipo o por estatus. 'Sólo sin cliente' muestra los equipos que todavía no tienen dueño registrado (el cliente es opcional).",
                            target: () => this.refFiltros.current,
                        },
                        {
                            title: "Listado",
                            description:
                                "Use el buscador o la lupa de cada columna para buscar por folio, serie, inventario o ID externo. Doble clic abre la ficha del activo, donde están sus notas, transferencias y (en siguientes etapas) su historial de servicios.",
                            target: () => this.refTabla.current,
                        },
                    ]}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(Activos);
